import React from 'react'
// styles 
import './Avatar.css'

export default function Avatar({ image }) {
  return (
    <div className='avatar'>
        <img src={image} alt="user avatar" />
    </div>
  )
}
